import api from './api'

export default {
  // GET /api/notificaciones
  async getAll () {
    const response = await api.get('/notificaciones')
    return response.data
  },

  // GET /api/notificaciones/no-leidas/count
  async getUnreadCount () {
    const response = await api.get('/notificaciones/no-leidas/count')
    return response.data
  },

  // POST /api/notificaciones/:id/leer
  async marcarLeida (id) {
    await api.post(`/notificaciones/${id}/leer`)
  },

  // POST /api/notificaciones/leer-todas
  async marcarTodasLeidas () {
    await api.post('/notificaciones/leer-todas')
  }
}
